import Vue from 'vue'
import VueRouter from 'vue-router'
import { getCookieToken } from '@/utils/auth.js'
import Utils from '@/utils/index.js'
const Layout = () => import('@/views/layout/Layout.vue')
const IndexPage = () => import(/* webpackChunkName: "index" */ '@/views/index/Index.vue')
const LandPage = () => import(/* webpackChunkName: "index" */ '@/views/landpage/LandPage.vue')
const DetailPage = () => import(/* webpackChunkName: "index" */ '@/views/detail/Detail.vue')
const VipPage = () => import(/* webpackChunkName: "index" */ '@/views/vip/Vip.vue')
const GamePage = () => import(/* webpackChunkName: "index" */ '@/views/game/Game.vue')
const ProfileModule = () => import(/* webpackChunkName: "index" */ '@/views/profile/Index/index.vue')
const Invite = () => import(/* webpackChunkName: "index" */ '@/views/invite/Invite.vue')
const TgPage = () => import(/* webpackChunkName: "index" */ '@/views/tg/TgPage.vue')
const IntroPage = () => import(/* webpackChunkName: "index" */ '@/views/intro/Intro.vue')
const GroupPage = () => import(/* webpackChunkName: "group" */ '@/views/group/Group.vue')
Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/',
            component: Layout,
            children: [
                {
                    path: '',
                    component: IndexPage
                }
            ]
        },
        {
            path: '/landpage',
            component: Layout,
            children: [
                {
                    path: '',
                    component: LandPage
                }
            ]
        },
        {
            path: '/detail',
            component: Layout,
            children: [
                {
                    path: '',
                    component: DetailPage
                }
            ]
        },
        {
            path: '/vip',
            component: Layout,
            children: [
                {
                    path: '',
                    component: VipPage
                }
            ]
        },
        {
            path: '/game',
            component: Layout,
            children: [
                {
                    path: '',
                    component: GamePage
                }
            ]
        },
        {
            path: '/profile',
            component: ProfileModule,
            meta: { isLogin: true }
        },
        {
            path: '/invite',
            component: Invite
        },
        {
            path: '/tg/:game_id',
            component: Layout,
            children: [
                {
                    path: '',
                    component: TgPage
                }
            ]
        },
        {
            path: '/intro',
            component: Layout,
            children: [
                {
                    path: '',
                    component: IntroPage
                }
            ]
        },
        // 暂时隐藏、后续打开
        /*{
            path: '/group',
            component: GroupPage
        },*/
        { path: '*', redirect: '/' }
    ]
})

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err)
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch((err) => err)
}

router.beforeEach((to, from, next) => {
    if (to.path.startsWith('/tg') || to.path.startsWith('/landpage')) {
        // 需要移除 name="keywords"
        const keywordsTag = document.querySelector('meta[name="keywords"]')
        if (keywordsTag) {
            keywordsTag.parentNode.removeChild(keywordsTag)
        }
        // 需要移除 name="description"
        const descriptionTag = document.querySelector('meta[name="description"]')
        if (descriptionTag) {
            descriptionTag.parentNode.removeChild(descriptionTag)
        }
    } else {
        setMetaTags()
    }
    const isLogin = to.meta.isLogin
    if (isLogin) {
        if (!getCookieToken()) {
            try {
                Vue.prototype.$Login.show({
                    scene: 'enter-page',
                    value: {
                        path: to.path,
                        query: to.query
                    }
                })
                if (to.path == '/vip') {
                    Utils.report({ event: '盒子家庭端百度推广按钮上报统计', event_id: 38, n3: 8 })
                }
            } catch (error) {
                router.push('/')
            }
        } else {
            next()
        }
    } else {
        next()
    }

    Utils.shouldShowAgreementUpdateDialog()
})

function setMetaTags() {
    // 设置 title
    document.title = '乐速盒子3A大作畅玩'

    // 设置 description
    let descriptionTag = document.querySelector('meta[name="description"]')
    if (!descriptionTag) {
        descriptionTag = document.createElement('meta')
        descriptionTag.setAttribute('name', 'description')
        document.head.appendChild(descriptionTag)
    }
    descriptionTag.setAttribute('content', '乐速盒子集合全球3A大作，热门游戏正版steam账号交易，会员免费畅玩全球3A大作，支持云存档，上千款游戏会员畅玩')

    // 设置 keywords
    let keywordsTag = document.querySelector('meta[name="keywords"]')
    if (!keywordsTag) {
        keywordsTag = document.createElement('meta')
        keywordsTag.setAttribute('name', 'keywords')
        document.head.appendChild(keywordsTag)
    }
    keywordsTag.setAttribute('content', 'steam下载、pubg畅玩、steam游戏官网会员免费畅玩、乐速盒子下载')
}

router.afterEach((to) => {
    if (to.path !== '/profile') {
        Vue.prototype.$nextTick(() => {
            $('.common-bottom').show()
        })
    } else {
        Vue.prototype.$nextTick(() => {
            $('.common-bottom').hide()
        })
    }
})

export default router
